const redirectLogoutUri = process.env.VUE_APP_URL_REDIRECT_LOGOUT;
const scope = process.env.VUE_APP_SCOPE;

import * as Msal from '@azure/msal-browser';
import User from '../types/auth/user';
import { msalInstance } from '@/msal';

const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account'
};

const tokenRequest: any = {
  scopes: [scope],
  forceRefresh: false
};

const graphRequest: any = {
  scopes: ['User.Read']
};

export class AuthService {
  msalInstance: Msal.PublicClientApplication;

  constructor() {
    this.msalInstance = msalInstance;
  }

  public async getAllAccountsAsync(){
    return await this.msalInstance.getAllAccounts();
  }

  public async logoutAsync() {
    await this.msalInstance.logout({
      postLogoutRedirectUri: redirectLogoutUri
    });
  }

  public async loginAsync(): Promise<boolean> {
    try {
      const { accessToken } = await this.msalInstance.loginPopup(loginRequest);

      return !!accessToken;
    } catch (error) {
      console.log('authService I: loginAsync()', error);
      return false;
    }
  }

  public async getTokenForRequiredAsync(): Promise<string | null> {
    try {
      const accounts = await this.msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        return null;
      }

      tokenRequest.account = accounts[0];

      const response = await this.msalInstance.acquireTokenSilent(tokenRequest);

      return response.accessToken;
    } catch (error) {
      console.log('authService: getTokenForRequiredAsync()', error);
      return null;
    }
  }

  public getTokenData(): User | null {
    try {
      const currentAccounts = this.msalInstance.getAllAccounts();
      if (currentAccounts.length === 0) {
        return null;
      }

      if (currentAccounts.length === 1) {
        const data = this.msalInstance.getAccountByUsername(currentAccounts[0].username);

        return {
          name: data?.name,
          email: data?.username
        } as User;
      }

      return null;
    } catch (error) {
      console.log('authService: getTokenData()', error);

      return null;
    }
  }

  public async getTokenGraph(): Promise<string | null> {
    try {
      const accounts = await this.msalInstance.getAllAccounts();

      if (!accounts || accounts.length === 0) {
        return null;
      }

      graphRequest.account = accounts[0];
      const response = await this.msalInstance.acquireTokenSilent(graphRequest);

      return response.accessToken;
    } catch (error) {
      console.log('authService I: getTokenGraph()', error);
      if (error.errorCode === 'invalid_grant') {
        try {
          const accounts = await this.msalInstance.getAllAccounts();

          graphRequest.account = accounts[0];
          const response = await this.msalInstance.acquireTokenPopup(graphRequest);

          return response.accessToken;
        } catch (error) {
          console.log('authService II: getTokenGraph()', error);
          return null;
        }
      }
      console.log('authService: getTokenGraph(): ', JSON.parse(JSON.stringify(error)));
      return null;
    }
  }
}
